module.exports = __webpack_public_path__ + "static/media/Mary-Williams.2dff20b1.jpg";